import React from 'react';

import { SimpleTextToggle } from '~/src/dash/components/toggles/SimpleTextToggle';
import { Col, Cols, spacing, Text } from '~/src/dash/publicaUI';
import { IDateRange } from '~/src/dash/utils/dateTimeRanges';

interface IDateGroup {
  label: string;
  value: number;
}

const dateGroups = [
  { label: 'Hour', value: 0 },
  { label: 'Day', value: 1 },
  { label: 'Week', value: 2 },
  { label: 'Month', value: 3 },
] as IDateGroup[];

interface IDateGroupSelectorProps {
  activeDateRange: IDateRange;
  activeGrouping: number;
  handleSelectGrouping: (dateGroup: number) => void;
}

export const DateGroupToggles = ({
  activeDateRange,
  activeGrouping,
  handleSelectGrouping,
}: IDateGroupSelectorProps) => {
  const { dateGroupRange } = activeDateRange;
  const [min, max] = dateGroupRange;
  return (
    <Cols
      gap={spacing.large}
      style={{
        justifyContent: 'flex-end',
        alignContent: 'center',
      }}
    >
      <Col>
        <Text
          extraSmall
          muted
          italic
          style={{ height: '28px', lineHeight: '28px', textAlign: 'center' }}
        >
          View By
        </Text>
      </Col>
      {dateGroups.map((group) => {
        const isAllowed = group.value >= min && group.value <= max;
        return (
          <Col>
            <SimpleTextToggle
              active={activeGrouping === group.value}
              disabled={!isAllowed}
              onClick={() => handleSelectGrouping(group.value)}
              value={group.label}
              size='small'
              tooltipText={!isAllowed ? 'Unavailable due to the selected period.' : ''}
            />
          </Col>
        );
      })}
    </Cols>
  );
};
